(() => {
  function bundleTotal(unitPrice, pairDiscount, quantity) {
    const safeQuantity = Math.max(0, Math.floor(Number(quantity) || 0));
    const safeUnitPrice = Math.max(0, Number(unitPrice) || 0);
    const safePairDiscount = Math.max(0, Number(pairDiscount) || 0);
    return (safeUnitPrice * safeQuantity) - (Math.floor(safeQuantity / 2) * safePairDiscount);
  }

  function formatMoney(cents, currency, locale) {
    // Keep the storefront's €179,- style consistent across all euro languages.
    const isEuro = currency === 'EUR';
    const parts = new Intl.NumberFormat(isEuro ? 'nl-NL' : locale, { style: 'currency', currency }).formatToParts(cents / 100);
    const wholeAmount = parts.some((part) => part.type === 'fraction' && /^0+$/.test(part.value));
    return parts.map((part) => {
      if (isEuro && part.type === 'literal') return '';
      if (wholeAmount && part.type === 'decimal') return ',';
      if (wholeAmount && part.type === 'fraction') return '-';
      return part.value;
    }).join('');
  }

  globalThis.KiddyViewProductLogic = Object.freeze({ bundleTotal, formatMoney });
})();
